import * as React from "react";

// Check whether an html element or one of its parents have the given class
export function hasClassInParent(element: HTMLElement, className: string): boolean {
  if (element.classList.contains(className)) {
    return true;
  }
  if (element.parentElement) {
    return hasClassInParent(element.parentElement, className);
  }

  return false;
}

const URL_REGEX = /(https?:\/\/[^\s<>"')]+[^\s.,;:!?<>"')])/g;

export const renderWithLinks = (text: string): React.ReactNode[] => {
  const nodes: React.ReactNode[] = [];
  let last = 0;

  for (const match of text.matchAll(URL_REGEX)) {
    const start = match.index!;
    const url = match[0];

    if (start > last) {
      // push the raw text before the link
      nodes.push(text.slice(last, start));
    }
    nodes.push(
      <a key={start} href={url} target="_blank" rel="noreferrer">
        {url}
      </a>
    );
    last = start + url.length;
  }
  if (last < text.length) {
    nodes.push(text.slice(last));
  }

  return nodes;
};
